import classNames from "classnames";
import { IDotsInputTextProps } from "dots-ui/dotsInputText";
import { AvisInputText, AvisPrefixDropdown } from "./";

interface IAvisInputTextWithFilterType<T> extends IDotsInputTextProps<T> {
  bagFieldFilterType: keyof T;
}

export function AvisInputTextWithFilterType<T = object>(
  props: Readonly<IAvisInputTextWithFilterType<T>>,
) {
  const { bag, bagFieldFilterType, className, disabled, ...restProps } = props;

  const classNameCombined = classNames("avis-input-text-filterable", className);

  return (
    <AvisInputText<T>
      bag={bag}
      className={classNameCombined}
      inputPrefix={
        <AvisPrefixDropdown
          bag={bag}
          bagFieldFilterType={bagFieldFilterType}
          disabled={disabled}
        />
      }
      prefixOverflow="visible"
      disabled={disabled}
      {...restProps}
    />
  );
}
